const materialOrderPopulate = {
    order_requests: {
        populate: {
            shipment: true,
            receipt_position: { populate: { receipt: true } },
        },
    },
}

export const materialRequirementsPopulate = {
    material_type: true,
    configurations: {
        populate: {
            material: {
                populate: {
                    ...materialOrderPopulate,
                    stocks: {
                        populate: {
                            stock_reserves: { populate: { shipment: true } },
                        },
                    },
                },
            },
        },
    },
}

export const shipmentAvailabilityPopulate = {
    stamp: { populate: ['tube', 'roller', 'last_order'] },
    virtualStamp: { populate: ['roller'] },
    form_set: {
        populate: {
            forms: { populate: { form_order: true } },
        },
    },
    additional_jobs: true,
    blankPreviewFiles: true,
}

const orderStatusFields = { fields: ['orderStatus', 'estimatedDate'] }

/** Только то, от чего зависят статусы колонки «Наличие» (Ш, Ф, М) — для опроса без сдвига списка */
export const shipmentAvailabilityRefreshPopulate = {
    fields: ['documentId'],
    populate: {
        stamp: {
            fields: ['documentId'],
            populate: { last_order: orderStatusFields },
        },
        form_set: {
            fields: ['documentId'],
            populate: {
                forms: {
                    fields: ['documentId'],
                    populate: { form_order: orderStatusFields },
                },
            },
        },
        materialRequirements: {
            populate: {
                configurations: {
                    populate: {
                        material: {
                            fields: ['documentId'],
                            populate: {
                                order_requests: {
                                    fields: ['requestStatus'],
                                    populate: {
                                        shipment: { fields: ['documentId'] },
                                        receipt_position: {
                                            fields: ['documentId', 'positionStatus'],
                                            populate: {
                                                receipt: {
                                                    fields: ['receiptStatus', 'estimatedDate'],
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
}

/** Менеджер (автор отгрузки), дизайнер и куратор — для колонок «Доп.» и «К» в плане печати и на станках */
export const shipmentPeoplePopulate = {
    user_audit: {
        populate: {
            created_by_permissions_user: {
                fields: ['documentId', 'username'],
            },
        },
    },
    designer: {
        fields: ['documentId', 'username'],
    },
    // Для колонки «К»: куратор по задаче согласования
    tasks: {
        filters: { type: { $eq: 'Согласование задания' } },
        fields: ['type', 'taskStatus', 'endDate', 'createdAt'],
        populate: {
            performer: { fields: ['documentId', 'username'] },
        },
    },
}
